import { axiosWalletRequest, axiosUserRequest, METHOD } from '../api/Requests';

export const getPaymentForms = async () => await axiosWalletRequest('Lancamento/FormasDePagamento', METHOD.GET);

export const exportTransaction = async (body) => await axiosUserRequest('LancamentoExportar/Exportar', METHOD.POST, body);

export const exportBalance = async (body) => await axiosUserRequest('LancamentoExportar/ExportarSaldo', METHOD.POST, body);
